import { keyboard } from "../../../../../input/keyboard"
import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type RotationNodeOptions = { rotation?: number } & SimpleManaNodeOptions


export default class RotationNode extends SimpleManaNode {

	rotation = 0

	static nodeName = "Add rotation node"
	static nodeDesc = "Adds rotation to current rotation"
	static nodeIcon = '🔄'
	static category = NodeCategories.Direction
	static nodeType = 'RotationNode'

	constructor({ rotation = 0, ...rest }: RotationNodeOptions) {
		super(rest)

		this.rotation = rotation
		this.symbol = this.getSymbol()
	}

	getSymbol() {
		if (!this.rotation) return RotationNode.nodeIcon
		if (this.rotation > 0) return ('+' + this.rotation + '°')
		return (this.rotation + '°')
	}

	onScroll(dir: number) {
		const amt = - dir * (keyboard.shiftDown ? 1 : 10)
		this.setRotation(this.rotation + amt)
	}

	setRotation(rotation: number) {
		this.rotation = rotation
		this.symbol = this.getSymbol()
		this.reloadSymbol()
	}

	async act(particle: ManaParticle) {
		if (particle.target) {
			particle.direction.rotateDeg(this.rotation)
		}

		return true
	}

	save() {
		return {
			...super.save(),

			rotation: this.rotation
		}
	}

}